import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { DefaultTimeframeStartDateType, RouteQueryParamStartDate } from 'utils/constants';
import { getPreferredMainPage } from 'utils/profile';

type InsightsRoutingAPI = {
  navigateTo: (to: string) => void;
  setStartTime: (dateStr: string) => void;
  navigateToDefault: () => void;
  setDefaultStartTime: () => void;
};

export function useInsightsRouting(): InsightsRoutingAPI {
  const navigate = useNavigate();
  const { search, pathname } = useLocation();

  const appNavigationAPI = useMemo<InsightsRoutingAPI>(
    () => ({
      navigateTo: (url: string) => navigate(url),
      setStartTime: (dateStr: string) =>
        navigate(`${pathname}?${RouteQueryParamStartDate}=${dateStr}`, { replace: true }),
      navigateToDefault: () => navigate(getPreferredMainPage() + search, { replace: true }),
      setDefaultStartTime: () =>
        navigate(`${pathname}?${RouteQueryParamStartDate}=${DefaultTimeframeStartDateType}`, {
          replace: true,
        }),
    }),
    [search, pathname]
  );

  return appNavigationAPI;
}
